import { cn } from '@/lib/utils';

interface SkipLinkProps {
  targetId?: string;
  className?: string;
}

export function SkipLink({ targetId = 'main-content', className }: SkipLinkProps) {
  return (
    <a
      href={`#${targetId}`}
      className={cn(
        'sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50',
        'focus:bg-background focus:text-foreground focus:px-4 focus:py-2 focus:rounded-md',
        'focus:ring-2 focus:ring-ring focus:outline-none',
        className
      )}
    >
      Skip to main content
    </a>
  );
}
